<template>
  <div v-if="currentNettoyage">
    <div class="mt-4 mb-4">
      <div
        class="row d-flex"
        :class="{
          'justify-content-center': currentNettoyage.statut.code === 1,
        }"
      >
        <div class="col-md-12 mt-1">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <span class="d-flex justify-content-between">
                      <span>
                        <i class="fa fa-calendar text-custom-primary"></i>
                        <span class="font-weight-bold"> Date</span>
                      </span>
                      <span>{{ currentNettoyage.date }}</span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="d-flex justify-content-between">
                      <span>
                        <i class="far fa-clock text-custom-primary"></i>
                        <span class="font-weight-bold"> Heure début</span>
                      </span>
                      <span>
                        {{ currentNettoyage.heure_debut }}
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="d-flex justify-content-between">
                      <span>
                        <i class="far fa-clock text-custom-primary"></i>
                        <span class="font-weight-bold"> Heure fin</span>
                      </span>
                      <span>
                        {{ currentNettoyage.heure_fin }}
                      </span>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" class="pt-4">
                    <span>
                      <i class="mdi mdi-comment-edit text-custom-primary"></i>
                      <span class="font-weight-bold"> Commentaire</span>
                    </span>
                    <div class="p-3">{{ currentNettoyage.commentaire }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="bg-white col-md-5 mt-3 mb-4">
          <div class="table-rsesponsive">
            <h5 class="text-center">
              <i class="fa fa-users mr-2 text-custom-primary"></i> Equipe
              planifiée
            </h5>
            <ul v-if="currentNettoyage.equipe.length > 0" class="list-group">
              <li
                v-for="person in currentNettoyage.equipe"
                :key="person.uuid"
                class="list-group-item"
              >
                <a
                  style="cursor: pointer"
                  title="aperçu employé"
                  @click.prevent="
                    $router.push({
                      name: 'rh_employe-show',
                      params: { id: person.id },
                    })
                  "
                  ><i class="fa fa-user mr-2"></i>{{ person.nom }}
                  <i
                    v-if="
                      currentNettoyage.statut.code === 1 && isAbsent(person)
                    "
                    class="mdi mdi-circle-slice-8 text-danger ml-2"
                  ></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="currentNettoyage.statut.code === 1" class="col-md-1"></div>
        <div
          v-if="currentNettoyage.statut.code === 1"
          class="bg-white col-md-5 mt-3 mb-4"
        >
          <h5 class="text-center">
            <i class="fa fa-users mr-2 text-custom-primary"></i> Equipe de
            réalisation
          </h5>
          <ul
            v-if="currentNettoyage.equipe_reelle.length > 0"
            class="list-group"
          >
            <li
              v-for="person in currentNettoyage.equipe_reelle"
              :key="person.uuid"
              class="list-group-item"
            >
              <a
                style="cursor: pointer"
                title="aperçu employé"
                @click.prevent="
                  $router.push({
                    name: 'rh_employe-show',
                    params: { id: person.id },
                  })
                "
                ><i class="fa fa-user mr-2"></i>{{ person.nom }}</a
              >
              <i
                v-if="isNew(person)"
                class="mdi mdi-circle-slice-8 text-custom-primary ml-2"
              ></i>
            </li>
          </ul>
        </div>
      </div>
      <div class="d-flex justify-content-end bg-white p-3">
        <div>
          <span class="mr-2"
            ><i class="far fa-user text-custom-primary"></i>
            <span class="font-weight-bold"> Auteur</span></span
          >
          <span> {{ currentNettoyage.auteur }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { VueEditor } from 'vue2-editor';
export default {
  props: {
    currentNettoyage: {
      type: Object,
      required: true,
    },
  },
  components: {
    // VueEditor,
  },
  methods: {
    isNew(emp) {
      return !this.currentNettoyage.equipe.some((e) => e.uuid === emp.uuid);
    },
    isAbsent(emp) {
      return !this.currentNettoyage.equipe_reelle.some(
        (e) => e.uuid === emp.uuid
      );
    },
  },
};
</script>

<style scoped></style>
